import { render } from "./PreviewDocumentationFiles.vue?vue&type=template&id=42edd261"
import script from "./PreviewDocumentationFiles.vue?vue&type=script&lang=js"
export * from "./PreviewDocumentationFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__